<style lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Raleway:300,400,600");

// @import "node_modules/bulma/bulma.sass";
.services {
    width: 90%;
    margin: 0 auto;

       .table {
        width: 100%;

        .sorting {
            background-image: url('/images/sort_both.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_asc {
            background-image: url('/images/sort_asc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_desc {
            background-image: url('/images/sort_desc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
    }

}


h1 {
    text-align: center;
    font-size: 30px;
}
</style>

<template>
<div>
    <div class="services" v-if="$gate.isAdmin() || $gate.isReception() || $gate.isManager() || $gate.isSupervisor()">

            <div class="row">
                <div class="col-sm-11">
                    <input type="text" class="form-control" v-model="tableData.search" placeholder="Search" @input="getServices()">
                </div>
                <div class="col-sm-1">
                    <select class="form-control" v-model="tableData.length" @change="getServices()">
                        <option v-for="(records, index) in perPage"
                        :key="index"
                        :value="records">{{records}}</option>
                    </select>
                </div>

                <div class="col-sm-12 mt-2">
                    <datatable :columns="columns"
                        :sortKey="sortKey"
                        :sortOrders="sortOrders"
                        @sort="sortBy">

                        <tbody>
                            <tr v-for="service in services" :key="service.id">
                                <td>{{service.name}}</td>
                                <td>{{service.price}}</td>
                                <td>{{service.xero}}</td>
                                <td>{{service.notes}}</td>
                                <td>
                                    <button type="button" class="btn btn-primary btn-md" data-toggle="modal" :data-target="'#vmbc'+ service.id"><i class="fa fa-edit blue"></i></button>

                                    <button type="button" class="btn btn-warning btn-md" data-toggle="modal" :data-target="'#vmbc_image'+ service.id"><i class="fas fa-images white"></i></button>
                                    <!-- Modal -->
                                    <imagesd :product="service"/>

                                    <button type="button" class="btn btn-success btn-md" data-toggle="modal" :data-target="'#vmbc_add'+ service.id" @click="getServicePrice(service.id)"><i class="fa fa-shopping-cart "></i></button>


                                    <Edit :id="service.id" :service="service"/>
                                    <Add :id="service.id" :servicename="service.name" :servicePrice="servicePrice"/>
                                </td>
                            </tr>
                        </tbody>
                    </datatable>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-4">
                    <excel
                        class = "btn btn-info"
                        :fetch   = "fetchExport"
                        :fields = "exportFields"
                        type    = "csv"
                        name = "Services.xls">
                        Download Excel
                    </excel>
                </div>
                <div class="col-sm-5">

                </div>
                <div class="col-sm-3">
                    <pagination :pagination="pagination"
                        @prev="getServices(pagination.prevPageUrl)"
                        @next="getServices(pagination.nextPageUrl)">
                </pagination>
                </div>
            </div>





    </div>
    <div class="row" v-else>
            <notfound></notfound>
    </div>
</div>
</template>


<script>
import Datatable from './../datatable/Datatable.vue';
import Pagination from './../datatable/Pagination.vue';
import Edit from './Service/Edit.vue';
import Add from './Service/Add.vue';
import imagesd from './Service/images.vue'
import JsonExcel from 'vue-json-excel';

export default {
    components: {datatable: Datatable, pagination: Pagination, excel: JsonExcel, Edit, Add, imagesd},
    data() {
        let sortOrders = {};
        let columns = [
            {width: '35%', label: 'Service', name: 'name'},
            {width: '10%', label: 'Price', name: 'price'},
            {width: '10%', label: 'Xero', name: 'xero'},
            {width: '25%', label: 'Notes', name: 'notes'},
            {width: '20%', label: 'Action', name: 'action'},
        ];

        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            services: [],
            columns: columns,
            sortKey: 'deadline',
            sortOrders: sortOrders,
            perPage: ['5', '10', '20', '30'],
            tableData: {
                draw: 0,
                length: 10,
                user_id: this.$root.id,
                name: this.$root.staffname,
                search: '',
                column: 0,
                dir: 'desc',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },
            exportFields: {
                'Service Name': 'classname',
                'Price': 'price',
                'Xero': 'xero',
            },
            showService: false,
            servicePrice: [],
        }
    },
    created(){
        this.getServices();
    },
    methods: {
        getServices(url = '/api/services'){
            this.tableData.draw++;
            axios
            .get(url, {params: this.tableData})
            .then(response => {
                let data = response.data;
                if(this.tableData.draw = data.draw) {
                    this.services = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1? 'asc' : 'desc';
            this.getServices();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        async fetchExport () {
            const response = await axios.get('/api/exportservice');
            console.log(response);
            return response.data;
        },

        getServicePrice(id) {
            axios
            .get('/api/Service/Price/'+id)
            .then((result) => {
                this.servicePrice = result.data;
            }).catch((err) => {
                console.log(err)
            });
        }

     }
}
</script>




// WEBPACK FOOTER //
// resources/js/Item/Services.vue